<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <router-link :to="{ name: 'paket-tambah'}"  class="btn btn-primary" >Tambah Paket</router-link>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Paket</h4>
                    <p class="card-category">Berikut daftar Paket anda</p>
                  </div>
                  <div class="col-md-6" v-show="false">
                    <h2 class="card-title text-right">{{filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Paket</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in area">
                        <td>{{ index+1 }}</td>
                        <td><strong>{{ u.nama }}</strong> </br>{{ u.keterangan }}</td>
                        <td>{{ ribu(u.tarif) }} / bulan</td>
                        <td>
                          <button v-show="isAllow()" @click="modalEdit = true, idPaket = u.id, namaPaket = u.nama, tarifPaket = u.tarif, keteranganPaket = u.keterangan" class="btn btn-sm btn-info" ><i class="material-icons">edit</i> Edit</button>
                          <button v-show="isAllow()" @click="modalHapus = true, nmHapus = u.nama, idHapus = u.id" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button>
                        </td>
                      </tr>
                      <tr v-if="area == null">
                        <td></td>
                        <td>Tidak ada Data / Tidak ada Area</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>

      <!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalEdit">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Paket</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalEdit = false">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-group">
                      <label class="bmd-label-floating">Nama Paket</label>
                      <input type="text" class="form-control" placeholder="Nama Paket..." v-model="namaPaket">
                    </div>
                    <div class="form-group">
                      <label class="bmd-label-floating">Tarif Paket (Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000)</label>
                      <input type="number" class="form-control" placeholder="Tarif..." v-model="tarifPaket">
                    </div>
                    <div class="form-group">
                      <label class="bmd-label-floating">Keterangan</label>
                      <input type="text" class="form-control" v-model="keteranganPaket">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" @click="Simpan">Simpan</button>
            </div>
          </div>
        </div>
      </div>

      
			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalHapus">
          <div class="overlay"></div>
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Hapus</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalHapus = false">
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="text-center">{{"Hapus Pelanggan "+nmHapus+" ?"}}</p>
                    </div>
                  </div>
                </div>
								<div class="modal-footer">
									<button type="button" class="btn btn-info" @click="modalHapus = false">Tidak</button>
									<button type="button" class="btn btn-secondary" @click="Hapus();modalHapus = false">Ya</button>
								</div>
            </div>
        </div>
    </div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'barcode': VueBarcode
  },
  data () {
    return {
      area: [],

      filtered: '',
      
      modalEdit: false,
      idPaket: '',
      namaPaket: '',
      tarifPaket: '',
      keteranganPaket: '',
      modalHapus: false,
      nmHapus: '',
      idHapus: ''
    }
  },
  methods: {
    Simpan() {
      /*
      var data = new FormData();

      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idPaket);
      data.append('nama', this.namaPaket);
      data.append('tarif', this.tarifPaket);
      data.append('keterangan', this.keteranganPaket);
      */

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        id: this.idPaket,
        nama: this.namaPaket,
        tarif: this.tarifPaket.replace(/[^0-9]/g, ''),
        keterangan: this.keteranganPaket
      }
      
      var apiUrl = inter.EditPaket(); // EditTarif
      this.PostData(data,apiUrl).then(x => {
        if (x.status == true) {
          this.modalEdit = false;
          this.getData();
        } else {
          this.textSalah = x.pesan;
        }
      })
    },
    Hapus() {

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        id: this.idHapus
      }
      
      var apiUrl = inter.HapusPaket(); // EditTarif
      this.PostData(data,apiUrl).then(x => {
        if (x.status == true) {
          this.getData();
        } else {
          
        }
      })
    },
    getData() {
      this.isCari = false;

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      }
      
      var apiUrl = inter.ListPaket();
      this.PostData(data,apiUrl).then(x => {
        if (x.status == true) {
          this.area = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    }
  },
  mounted () {
    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/paket.vue